/* @flow weak */
import React from 'react';
import Image from 'components/Image.jsx';
import './styles/ChequeImageView.scss';
import cx from 'classnames';

export const ROUTING_NUMBER = 'routing_number';
export const ACCOUNT_NUMBER = 'account_number';

export const ChequeImageView = ({ highlighted }) => {
  return (
    <div className="ChequeImageView">
      <Image
        className="ChequeImageView-background"
        src={require('assets/images/payments/ChequeImageView/check.png')}
      />
      <Image
        className={cx('ChequeImageView-routingNumber', {
          'ChequeImageView-routingNumber-highlighted': highlighted === ROUTING_NUMBER,
        })}
        src={require('assets/images/payments/ChequeImageView/routing-number.svg')}
      />
      <Image
        className={cx('ChequeImageView-accountNumber', {
          'ChequeImageView-accountNumber-highlighted': highlighted === ACCOUNT_NUMBER,
        })}
        src={require('assets/images/payments/ChequeImageView/account-number.svg')}
      />
    </div>
  );
};

ChequeImageView.propTypes = {
  highlighted: React.PropTypes.oneOf([ROUTING_NUMBER, ACCOUNT_NUMBER]),
};



// WEBPACK FOOTER //
// ./src/payments/components/ChequeImageView.jsx